/* Picobellonails productpagina: varianten, galerij, aantal, vaste knop op gsm, "Voeg alles toe". */
(function () {
  const money = (cents) => {
    const format = (window.Shopify && window.Shopify.currency && window.theme && window.theme.moneyFormat) || null;
    const value = (cents / 100).toFixed(2).replace('.', ',');
    return format ? format.replace(/\{\{\s*\w+\s*\}\}/, value) : '€' + value;
  };

  function initProduct(root) {
    if (root.dataset.pbReady) return;
    root.dataset.pbReady = 'true';

    const variants = JSON.parse(root.querySelector('[data-pb-variants]').textContent);
    const idInput = root.querySelector('[data-pb-variant-id]');
    const addBtn = root.querySelector('[data-pb-add]');
    const addLabel = root.querySelector('[data-pb-add-label]');
    const priceBox = root.querySelector('[data-pb-price]');
    const stickyPrice = root.querySelector('[data-pb-sticky-price]');
    const stickyVariant = root.querySelector('[data-pb-sticky-variant]');
    const stickyLabel = root.querySelector('[data-pb-sticky-label]');
    const stickyImg = root.querySelector('[data-pb-sticky-img]');
    const syncSticky = (variant) => {
      const button = root.querySelector('[data-pb-sticky-add]');
      if (!button) return;
      button.disabled = !variant || !variant.available;
      if (stickyLabel) stickyLabel.textContent = !variant ? 'Niet beschikbaar' : variant.available ? 'In winkelmand' : 'Uitverkocht';
      if (!variant) return;
      if (stickyVariant) stickyVariant.textContent = variant.title;
      const src = variant.featured_image && variant.featured_image.src;
      if (stickyImg && src) {
        const url = new URL(src, window.location.origin);
        url.searchParams.set('width', '160');
        stickyImg.removeAttribute('srcset');
        stickyImg.src = url.toString();
      }
    };
    const fieldsets = [...root.querySelectorAll('[data-pb-option]')];
    const track = root.querySelector('[data-pb-track]');
    const thumbs = [...root.querySelectorAll('[data-pb-thumb]')];
    const dots = [...root.querySelectorAll('.pb-gallery__dot')];
    const priceTemplate = priceBox ? priceBox.querySelector('.pb-pdp__price-now').textContent.trim() : '';

    // Geldnotatie van de winkel afleiden uit de getoonde prijs (bv. "€9,99 EUR").
    const formatPrice = (cents) => {
      const value = (cents / 100).toFixed(2).replace('.', ',');
      const match = priceTemplate.match(/^([^\d]*)[\d.,]+(.*)$/);
      return match ? match[1] + value + match[2] : money(cents);
    };

    /* ---------- Galerij ---------- */
    const slides = track ? [...track.children] : [];
    const setActive = (index) => {
      thumbs.forEach((t, i) => {
        t.classList.toggle('is-active', i === index);
        t.toggleAttribute('aria-current', i === index);
      });
      dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
    };
    const goTo = (index, smooth = true) => {
      const slide = slides[index];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      setActive(index);
    };
    thumbs.forEach((t) => t.addEventListener('click', () => goTo(Number(t.dataset.pbThumb))));
    if (track && slides.length > 1) {
      let raf;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const index = Math.round(track.scrollLeft / track.clientWidth);
          setActive(Math.max(0, Math.min(slides.length - 1, index)));
        });
      }, { passive: true });
    }

    /* ---------- Varianten ---------- */
    const selected = () => fieldsets.map((fs) => fs.querySelector('input:checked')?.value);
    const updateVariant = () => {
      if (!fieldsets.length) return;
      const values = selected();
      fieldsets.forEach((fs, i) => {
        const label = fs.querySelector('[data-pb-option-value]');
        if (label) label.textContent = values[i] || '';
      });
      const variant = variants.find((v) => v.options.every((o, i) => o === values[i]));
      if (!variant) {
        addBtn.disabled = true;
        addLabel.textContent = 'Niet beschikbaar';
        syncSticky(null);
        return;
      }
      idInput.value = variant.id;
      addBtn.disabled = !variant.available;
      addLabel.textContent = variant.available ? 'In winkelmand' : 'Uitverkocht';
      if (priceBox) {
        const sale = variant.compare_at_price && variant.compare_at_price > variant.price;
        priceBox.innerHTML =
          `<span class="pb-pdp__price-now${sale ? ' is-sale' : ''}">${formatPrice(variant.price)}</span>` +
          (sale ? `<s class="pb-pdp__price-old">${formatPrice(variant.compare_at_price)}</s>` : '');
      }
      if (stickyPrice) stickyPrice.textContent = formatPrice(variant.price);
      syncSticky(variant);
      const together = root.querySelector('[data-pb-together-main]');
      if (together) together.dataset.variantId = variant.id;
      if (variant.featured_media) {
        const index = slides.findIndex((s) => s.dataset.mediaId === String(variant.featured_media.id));
        if (index >= 0) goTo(index);
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    };
    fieldsets.forEach((fs) => fs.addEventListener('change', updateVariant));

    /* ---------- Aantal ---------- */
    const qty = root.querySelector('.pb-qty__input');
    root.querySelectorAll('[data-pb-qty]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const next = Math.max(1, (parseInt(qty.value, 10) || 1) + Number(btn.dataset.pbQty));
        qty.value = next;
      });
    });

    /* ---------- Vaste balk onderaan ---------- */
    const sticky = root.querySelector('[data-pb-sticky]');
    const stickyAdd = root.querySelector('[data-pb-sticky-add]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      const header = document.querySelector('.section-pb-header');
      const headerHeight = header ? header.offsetHeight : 0;
      const io = new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < headerHeight;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
        stickyAdd.tabIndex = show ? 0 : -1;
      }, { rootMargin: `-${headerHeight}px 0px 0px 0px` });
      io.observe(addBtn);
      stickyAdd.addEventListener('click', () => addBtn.click());
      // Laadanimatie van de gewone knop overnemen
      new MutationObserver(() => {
        const busy = addBtn.classList.contains('loading') || addBtn.getAttribute('aria-disabled') === 'true';
        stickyAdd.classList.toggle('is-loading', busy);
      }).observe(addBtn, { attributes: true, attributeFilter: ['class', 'aria-disabled'] });
    }

    /* ---------- Vaak samen gekocht ---------- */
    const addAll = root.querySelector('[data-pb-add-all]');
    if (addAll) {
      addAll.addEventListener('click', async () => {
        const items = [...root.querySelectorAll('[data-pb-together] [data-variant-id]')].map((row) => ({
          id: Number(row.dataset.variantId),
          quantity: 1,
        }));
        const drawer = document.querySelector('cart-drawer');
        addAll.disabled = true;
        const original = addAll.textContent;
        try {
          const res = await fetch(window.routes.cart_add_url + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items,
              sections: drawer ? drawer.getSectionsToRender().map((s) => s.id) : [],
              sections_url: window.location.pathname,
            }),
          });
          const data = await res.json();
          if (data.status) throw new Error(data.description || 'Toevoegen mislukt');
          if (drawer) {
            drawer.classList.remove('is-empty');
            drawer.renderContents(data);
          } else {
            window.location = window.routes.cart_url;
          }
          addAll.textContent = 'Toegevoegd';
          setTimeout(() => (addAll.textContent = original), 1800);
        } catch (e) {
          addAll.textContent = 'Lukt niet, probeer apart';
          setTimeout(() => (addAll.textContent = original), 2500);
        } finally {
          addAll.disabled = false;
        }
      });
    }
  }

  const init = () => document.querySelectorAll('[data-pb-product]').forEach(initProduct);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
